import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'pratiche';

const getPratiche = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_pratiche" , data: params}, callback);

const apiEndpoint = {
  getPratiche,
}

export default apiEndpoint;